/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Highlights_Plan_Day_SameInputs */

const en_us2_workout_highlights_plan_day_same = /** @type {(inputs: Workout_Highlights_Plan_Day_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the same volume`)
};

const pt_br2_workout_highlights_plan_day_same = /** @type {(inputs: Workout_Highlights_Plan_Day_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`o mesmo volume`)
};

const es_419_workout_highlights_plan_day_same = /** @type {(inputs: Workout_Highlights_Plan_Day_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`el mismo volumen`)
};

const pt_pt2_workout_highlights_plan_day_same = /** @type {(inputs: Workout_Highlights_Plan_Day_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`o mesmo volume`)
};

const fr_fr2_workout_highlights_plan_day_same = /** @type {(inputs: Workout_Highlights_Plan_Day_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`le même volume`)
};

const de_de2_workout_highlights_plan_day_same = /** @type {(inputs: Workout_Highlights_Plan_Day_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dasselbe Volumen`)
};

const it_it2_workout_highlights_plan_day_same = /** @type {(inputs: Workout_Highlights_Plan_Day_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lo stesso volume`)
};

/**
* | output |
* | --- |
* | "the same volume" |
*
* @param {Workout_Highlights_Plan_Day_SameInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_highlights_plan_day_same = /** @type {((inputs?: Workout_Highlights_Plan_Day_SameInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Highlights_Plan_Day_SameInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_highlights_plan_day_same(inputs)
	if (locale === "es-419") return es_419_workout_highlights_plan_day_same(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_highlights_plan_day_same(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_highlights_plan_day_same(inputs)
	if (locale === "de-DE") return de_de2_workout_highlights_plan_day_same(inputs)
	if (locale === "it-IT") return it_it2_workout_highlights_plan_day_same(inputs)
	return en_us2_workout_highlights_plan_day_same(inputs)
});
export { workout_highlights_plan_day_same as "workout-highlights.plan_day_same" }